import { UserEntity } from 'Domain/User/Entity/User';
import { User } from 'Domain/User/Entity/User';
import executeRequest from 'Infrastructure/WebClient';
import * as RequestTypes from 'Application/RequestTypes';
import { UpdateUserRequest } from 'Domain/User/Dto/UpdateUserRequest';
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from 'pages/Hooks/useLocalStorage';
import { USER_DATA_STORAGE_KEY } from 'pages/constants/StorageKeys';

export function setUserData(userData: any) {
  setLocalStorageItem(USER_DATA_STORAGE_KEY, userData);
}

export function getCurrentUserData() {
  const data = getLocalStorageItem(USER_DATA_STORAGE_KEY);
  return new UserEntity(data ? data : {});
}

export async function getUserData(publicId: string) {
  return executeRequest<User>(RequestTypes.USER_DATA, [], {
    id: publicId,
  }).then((res) => {
    if ('profile' in res) {
      // if (Object.hasOwn(res.profile, 'mobile')) {
      //   res.profile.mobile = res.profile.mobile.slice(3);
      // }
      // if (Object.hasOwn(res.profile, 'phone')) {
      //   res.profile.phone = res.profile.phone.slice(3);
      // }
    }
    return res;
  });
}

export async function updateUserData(
  publicId: string,
  updateUserRequest: UpdateUserRequest,
) {
  return executeRequest(RequestTypes.UPDATE_USER_DATA, updateUserRequest, {
    id: publicId,
  }).then(() => {
    return getUserData(publicId);
  });
}

export function signUserContract(signature: string) {
  return executeRequest(RequestTypes.SIGN_USER_CONTRACT, {
    signature: signature,
  });
}

export function validateUserProfile(id: string) {
  return executeRequest(RequestTypes.INTERNAL_USER_VALIDATION, [], { id: id });
}

export function deleteInternalUser(publicId: string) {
  return executeRequest(RequestTypes.DELETE_INTERNAL_USER, [], {
    id: publicId,
  });
}

export function impersonateUser(id: string) {
  return executeRequest(RequestTypes.IMPERSONATE_USER, [], {
    id: id,
  });
}
